import { makeStyles } from '@material-ui/core/styles';

export const useJobInfoStyles = makeStyles({
  input: {
    margin: '8px 0px',
  },
  inputNoMarginRight: {
    margin: '8px 0px 8px 15px',
  },
  black: {
    color: 'black !important',
  },
  whiteBox: {
    marginBottom: '20px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '1px solid lightgray',
    padding: '10px',
    width: '100%',
  },
  titleTab: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
    borderBottom: '1px solid black',
  },
  titleFont: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
});